module.exports = __webpack_public_path__ + "img/11.d4636502.svg";